import { useContext, useEffect, useState } from 'react'
import { Box } from '@mui/material'

// others
import { AppContext } from '../context'
import { flexCenter } from '../theme/styleConstants'
import { ActionType } from '../context/AppContextReducer'
import { useDebounce } from 'use-debounce'
import { GRAPHQL_QUERY_POLICY, PAGE_LIMIT } from '../constants'
import { ReferralSource, useFetchAllReferralSourcesLazyQuery } from '../../generated'

// components
import { CardBox } from '../theme/styleComponents'
import { ContentHead } from '../components/common/ContentHead'
import { SearchWithKeypress } from '../components/common/SearchWithKeypress'
import { EmptyData } from '../components/common/EmptyData'
import AddReferralSource from '../components/referralSources/AddReferralSource'
import ReferralSourcesListing from '../components/referralSources'

const ReferralSourcesContainer = () => {
  const [referralSources, setReferralSources] = useState<ReferralSource[]>([])
  const { isOpen, searchValue, currentPage, dispatch } = useContext(AppContext)
  const [debouncedSearch] = useDebounce(searchValue, 500)

  const [fetchAllReferralSources, { refetch, loading }] = useFetchAllReferralSourcesLazyQuery({
    ...GRAPHQL_QUERY_POLICY,
    variables: undefined,

    onError(error) {
      console.error('Error fetching referral sources', error)
      setReferralSources([])
    },
    onCompleted(data) {
      const { fetchAllReferralSources } = data
      const { referralSources, pagination } = fetchAllReferralSources
      setReferralSources(referralSources as ReferralSource[])
      dispatch({ type: ActionType.SET_CURRENT_PAGE, currentPage: pagination?.page || 1 })
      dispatch({ type: ActionType.SET_TOTAL_DATA_COUNT, totalDataCount: pagination?.totalCount || 1 })
      dispatch({ type: ActionType.SET_TOTAL_PAGE_COUNT, totalPageCount: pagination?.totalPages || 1 })
    }
  })

  useEffect(() => {
    ;(async () =>
      await fetchAllReferralSources({
        variables: {
          fetchAllSources: {
            paginationOptions: {
              limit: PAGE_LIMIT,
              page: currentPage
            },
            keyword: debouncedSearch
          }
        }
      }))()
  }, [fetchAllReferralSources, currentPage, debouncedSearch])

  useEffect(() => {
    return () => dispatch({ type: ActionType.SET_CURRENT_PAGE, currentPage: 1 })
  }, [dispatch])

  const isEmpty = !loading && referralSources.length === 0
  const handleClose = () => dispatch({ type: ActionType.SET_IS_OPEN, isOpen: false })

  return (
    <CardBox marginTop={3}>
      <ContentHead title={'Referral Types'} buttonText={'Add Referral Type'} />

      <Box display={'flex'} flex={1} justifyContent={'space-between'} alignItems={'center'} m={2}>
        <SearchWithKeypress searchPlaceholder={'Search Types'} />
      </Box>

      {isEmpty ? (
        <Box sx={{ ...flexCenter, height: 'calc(100vh - 400px)' }}>
          <EmptyData title={'No Types!'} />
        </Box>
      ) : (
        <ReferralSourcesListing referralSources={referralSources} loading={loading} refetch={refetch} />
      )}
      <AddReferralSource isOpen={isOpen} handleClose={handleClose} />
    </CardBox>
  )
}

export default ReferralSourcesContainer
